import { gql } from '@urql/core';
import { CollegeDetailsFragment } from 'generated/spin-graphql';
import React from 'react';
import { CollegeMediaCard } from '../profile-page/CollegeMediaCard';
import { CollegeBioCard } from '../profile-page/CollegeBioCard';
import { ScholarshipCard } from '../profile-page/ScholarshipCard';
import { OurEsportsCard } from '../profile-page/OurEsportsCard';
import { CollegeLocationCard } from '../profile-page/CollegeLocationCard';
import { AcademicRequirementsCard } from '../profile-page/AcademicRequirementsCard';

gql`
    fragment CollegeProfile on espin_college {
        program_name
        scholarships
        ...CollegeBioCard
        ...AcademicRequirementsCard

        header_media_link {
            link_data
            link_type
        }
        college_images {
            file {
                id
            }
        }
        college_games {
            ...OurEsportsCard
        }
        ...CollegeLocationCard
        ...CollegeSocials
        ...CollegeMediaCard
    }
`;

export function CollegeProfile({ college }: { college: CollegeDetailsFragment }) {
    const hasMedia = college.header_media_link?.link_data || college.college_images.length != 0;

    return (
        <>
            <div className="left-side-profile">
                <CollegeBioCard college={college} />
                {hasMedia && <CollegeMediaCard college={college} />}
            </div>
            <div className="right-side-profile">
                {college.scholarships && <ScholarshipCard />}
                {college.college_games && <OurEsportsCard games={college.college_games} />}
                {college.address && <CollegeLocationCard college={college} />}
                {college.min_gpa && <AcademicRequirementsCard academicRequirements={college} />}
            </div>
        </>
    );
}
